/* Based on https://www.deque.com/blog/a11y-support-series-part-1-aria-tab-panel-accessibility/ */
/* Not tested with multiple tab sets on the same page, may not work properly */
/* todo: links to target elements should select the tab for that element */
export default () => jQuery(($) => {

	function getCookie(name) {
		var regex = new RegExp(name + '=([^;]+)');
		var val = regex.exec(document.cookie);

		return (val != null) ? val[1] : null;
	}

	function setCookie(name, value, days) {
		var path = window.location.pathname;
		var expires = '';
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = '; expires=' + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=" + path;
	}

	function updateTabContent(tabs, tabThis, tabPanel) {
		var thisPanel = $('#' + tabThis.attr('aria-controls'));
		tabs.attr('aria-selected', 'false').removeClass('standard-tab__wrap--current');
		tabThis.attr('aria-selected', 'true').addClass('standard-tab__wrap--current');
		tabPanel.find('.tab-panel__panel').hide();
		thisPanel.show();
	}

	var hashSet = false;
	var hashes = [];
	if (window.location.hash) {
		hashes = window.location.hash.substring(1).split(',');
	}
	$(".tab-panel").each(function() {
		var tab_panel = $(this);
		var tabs = tab_panel.find('.standard-tab__wrap');
		tabs.each(function(){
			var id = $(this).attr('id');
			if (hashes.includes(id)) {
				updateTabContent(tabs, $(this), tab_panel);
				hashSet = true;
			} else if (getCookie('activeTab') === id && hashSet === false) {
				updateTabContent(tabs, $(this), tab_panel);
			}
			$(this).click(function(e) {
				window.history.replaceState('', document.title, '#'+id);
				setCookie('activeTab', id, 30);
				updateTabContent(tabs, $(this), tab_panel);
			});
		});
		tab_panel.find(".standard-tabs").keydown(function(e) {
			switch(e.keyCode) {
				case 37:
				case 38:
					var prev = tabs.filter(".standard-tab__wrap--current").parent().prev();
					if(prev.length) {
						prev.find(".standard-tab__wrap").click().focus();
					} else { // wrap around
						tabs.last().click().focus();
					}
					e.preventDefault();
					break;
				case 39:
				case 40:
					var next = tabs.filter(".standard-tab__wrap--current").parent().next();
					if(next.length) {
						next.find(".standard-tab__wrap").click().focus();
					} else { // wrap around
						tabs.first().click().focus();
					}
					e.preventDefault();
					break;
			}
		});
	});
});
